import React from 'react';
import { Grid, GridRow, GridColumn } from "semantic-ui-react";

import wBL from "../../../../img/AboutDarts/SDC-widget-best-of-legs.png";
import wAr from "../../../../img/AboutDarts/SDC-widget-average.png";
import wCo from "../../../../img/AboutDarts/SDC-widget-checkout.png";
import wDM from "../../../../img/AboutDarts/SDC-widget-doubles-missed.png";
import wSW from "../../../../img/AboutDarts/SDC-widget-num-shoots-for-leg-win.png";
import wRS from "../../../../img/AboutDarts/SDC-widget-rounds-stats.png";
import wS8 from "../../../../img/AboutDarts/SDC-widget-stats180.png";

const AboutDartsWidgets: React.FC = () => {
    let counter = 1;
    return (
        <Grid>
            <GridRow>
                <GridColumn width={8}>
                    <h3>{counter++}. Best of Legs</h3>
                    <p>main widget in your competition video stream.</p>
                    <p>
                        <a href={wBL} target="_blank" rel="noreferrer">
                            <img src={wBL} alt="BestOfLegs" width="320px" />
                        </a>
                    </p>
                </GridColumn>
                <GridColumn width={8}>
                    <h3>{counter++}. Average</h3>
                    <p>average value of 3-shots in current game,</p>
                    <p>can be combined with number of rounds 180 in game.</p>
                    <p>
                        <a href={wAr} target="_blank" rel="noreferrer">
                            <img src={wAr} alt="Average" width="320px" />
                        </a>
                    </p>
                </GridColumn>
            </GridRow>
            <GridRow>
                <GridColumn width={8}>
                    <h3>{counter++}. Rounds stats</h3>
                    <p>round stats by values</p>
                    <p>
                        <a href={wRS} target="_blank" rel="noreferrer">
                            <img src={wRS} alt="Rounds stats" width="320px" />
                        </a>
                    </p>
                </GridColumn>
                <GridColumn width={8}>
                    <h3>{counter++}. Checkouts</h3>
                    <p>number of checkouts per attempts and highest checkuot in game.</p>
                    <p>
                        <a href={wCo} target="_blank" rel="noreferrer">
                            <img src={wCo} alt="Checkouts" width="320px" />
                        </a>
                    </p>
                </GridColumn>
            </GridRow>
            <GridRow>
                <GridColumn width={8}>
                    <h3>{counter++}. Num Shoots</h3>
                    <p>number of shoots for leg win.</p>
                    <p>
                        <a href={wSW} target="_blank" rel="noreferrer">
                            <img src={wSW} alt="CMS" width="320px" />
                        </a>
                    </p>
                </GridColumn>
                <GridColumn width={8}>
                    <h3>{counter++}. Stats 180s</h3>
                    <p>uses for tournaments to show total rounds 180s in week or series.</p>
                    <p>
                        <a href={wS8} target="_blank" rel="noreferrer">
                            <img src={wS8} alt="Stats 180s" width="320px" />
                        </a>
                    </p>
               </GridColumn>
            </GridRow>
            <GridRow>
                <GridColumn width={8}>
                    <h3>{counter++}. Doubles Missed</h3>
                    <p>special option for game,</p>
                    <p>shows double attempts before scoring start.</p>
                    <p>
                        <a href={wDM} target="_blank" rel="noreferrer">
                            <img src={wDM} alt="Doubles Missed" width="320px" />
                        </a>
                    </p>
                </GridColumn>
            </GridRow>
        </Grid>
    );
}

export default AboutDartsWidgets;